var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 62,
    viewBox: "0 0 61 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.8337 54.1028V49.0195C50.8337 46.3231 49.7625 43.7372 47.8559 41.8305C45.9493 39.9239 43.3634 38.8528 40.667 38.8528H20.3337C17.6373 38.8528 15.0514 39.9239 13.1447 41.8305C11.2381 43.7372 10.167 46.3231 10.167 49.0195V54.1028",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4997 28.6861C36.1146 28.6861 40.6663 24.1343 40.6663 18.5194C40.6663 12.9046 36.1146 8.35278 30.4997 8.35278C24.8848 8.35278 20.333 12.9046 20.333 18.5194C20.333 24.1343 24.8848 28.6861 30.4997 28.6861Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.55b3c98b62de844303814ec0a9603244.svg";
export { ForwardRef as ReactComponent };